'use client';
import { cx } from '@linaria/core';
import type React from 'react';

import { Modal } from '~components/Modals/Base';
import { Text } from '~components/Typography';
import { languagesAsArray, useLanguage } from '~features/language';
import { useTranslations } from '~i18n/hooks';
import CloseIcon from '~public/assets/icons/close.svg';
import CheckInCircle from '~public/assets/icons/navigation/checkInCircle.svg';
import { useHeaderContext } from '~widgets/Header/context';

import { CloseButton, Divider, Item, StyledTitle, Wrapper } from './styles';

export const LanguageMenuModal = () => {
	const { isLanguageOpen, headerOffset, languageClose } = useHeaderContext();
	const t = useTranslations('ProfileMenu');
	const { locale: selectedLocale, changeLanguage } = useLanguage();
	return (
		<Modal
			style={
				{ '--header-offset': `${headerOffset}px` } as React.CSSProperties &
					Record<string, string | number>
			}
			withBackdrop={false}
			open={isLanguageOpen}
			onClose={languageClose}
			locked={false}
			data-name="language-menu-modal"
		>
			<Wrapper>
				<StyledTitle align="left" size="L">
					{t('modalLanguageTitle')}
				</StyledTitle>
				<Divider />
				<CloseButton onClick={languageClose} leftIcon={<CloseIcon />} />
				{languagesAsArray.map(({ name, locale }) => (
					<Item
						onClick={() => {
							void changeLanguage(locale);
						}}
						className={cx(selectedLocale === locale && 'selected')}
						key={locale}
					>
						<Text align="left" size="L">
							{name} ({locale.toUpperCase()})
						</Text>
						{selectedLocale === locale && <CheckInCircle />}
					</Item>
				))}
			</Wrapper>
		</Modal>
	);
};
